import {http} from './index';
import {GetLogs} from '@types';

export const getLogs = (params: GetLogs) => http.get('/calais/v1/backend/logs', params);